module.exports = __webpack_public_path__ + "img/53-image-2@2x.c61eb4cd.png";